module.exports = __webpack_public_path__ + "img/ResidentControl1.ced06122.png";